<template>
  <section class="section mobile_div section_bg container-fluid  first_page"  style="max-height: 100%" :class="{'help_page':(is_load==true && category.list_style=='default')}"  >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="d-flex justify-content-center" v-if="is_load==true">
    <div class="section_header container back_div_element no_margin " v-if="is_load==true">
      <router-link tag="a" class="btn" :to="{name: 'pages_category',params:{alias:category.alias}}"  ><i class="fa fa-backward"></i> Назад</router-link>

    </div>
    </div>

    <div class="row" v-if="is_load==true">

      <div class="col-12">
        <div class="row">
          <div class="container second_section"  v-if="page.content.blocks">
            <h2 class="ml-3 text-center">  {{ page.title }} </h2>
            <editorjsrender  class="ml-3" v-if="is_load && page.content.blocks " :blocks_json="page.content.blocks"></editorjsrender>
          </div>


        </div>
      </div>
    </div>
  </section>
 </template>

<script>
import Api from "@/models/Api";
import Editorjsrender from "@/models/Editorjsrender";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "PagesPage",
  data: function () {
    return {
      page:[],
      pages:[],
      category:[],
      is_load:false,

    }
  },
  mounted() {
    var app=this;
    let alias = app.$route.params.alias;
    let alias_page = app.$route.params.page_alias;
    Api.Pages_GetPage(alias,alias_page,function(data){
      var page=data.page;

      app.page=page;
      app.pages=data.pages;
      app.category=data.category;
      app.is_load=true;

    },function(data){
      app.$router.push({name:'404'});
    });
  },
  components: {
    'editorjsrender': Editorjsrender,
    LoadingBlock,
  }
}
</script>

<style scoped>

</style>